export default class Sorter{

    constructor(){
        this._stabilityList = [
            "very understable", "understable", "neutral", "stable", "overstable", "very overstable"
        ];
        this._skillList = [
            "everyone", "beginner", "beginner plus", "intermediate", "intermediate plus", "advanced"
        ];
    }

    CalculateScore(elementProperty, searchProperty)
    {
        let value = 0;
        if(elementProperty == searchProperty) {return 100;}
        if(elementProperty == 0) {value = (elementProperty / Math.abs(searchProperty)) * 100;}
        else if(searchProperty == 0) {value = (searchProperty / Math.abs(elementProperty)) * 100;}
        else if(searchProperty > elementProperty) {value = (elementProperty / searchProperty) * 100;}
        else if(elementProperty > searchProperty) {value = (searchProperty / elementProperty) * 100;}
        else {value = searchProperty/elementProperty;}
        if (value > 100)
        {
            value = value - 100;
        }
        return value;
    }

    CalculateListScore(elementStab, searchStab)
    {
        const eStabIndex = this._stabilityList.findIndex((e) => e == elementStab.toLowerCase()) + 1;
        const sStabIndex = this._stabilityList.findIndex((e) => e == searchStab.toLowerCase()) + 1;
        if (eStabIndex > sStabIndex)
        {
            return (sStabIndex / eStabIndex) * 100;
        }
        else if (eStabIndex < sStabIndex)
        {
            return (eStabIndex / sStabIndex) * 100;
        }
        else
        {
            return 100;
        }
    }
 
    
    ScoreDisc(list, searchObj)
    {
        list.forEach((e) => {
            const speedScore = this.CalculateScore(e.speed, searchObj.speed);
            const turnScore = this.CalculateScore(e.glide, searchObj.glide);
            const fadeScore = this.CalculateScore(e.fade, searchObj.fade);
            const stabScore = this.CalculateListScore(e.stability, searchObj.stability);
            const skillScore = this.CalculateListScore(e.skill, searchObj.skill);
            let percentMatch = ((speedScore + turnScore + fadeScore + stabScore + skillScore) / 5) > 100 
                ? ((speedScore + turnScore + fadeScore + stabScore + skillScore) / 5) -100  
                : (speedScore + turnScore + fadeScore + stabScore + skillScore) / 5;
            e.percentMatch = percentMatch;
        });
        return list;
    }

    RemovePercentMatch(list)
    {
        list.forEach((e) => {
            delete e.percentMatch;
        })
        return list;
    }

    Sort(list, searchObj){

        if(searchObj.brand != null || searchObj.brand != undefined)
        {
            this.ScoreDisc(list, searchObj);
            let r = list.sort((a, b) => {
                return b.percentMatch - a.percentMatch;
            });
            r = this.RemovePercentMatch(r);
            
            return r;
        }
        return list;
    }

    PlaceMatches(discraftList, list, searchObj)
    {
        if(searchObj == {}) return list;
        if(searchObj.matches != "" || searchObj.matches != null || searchObj.matches != undefined)
        {
            const exists = list.findIndex(disc => disc.model == searchObj.matches);
            if(exists != -1)
            {
                const discx = list[exists];
                list.splice(exists, 1);
                list.unshift(discx);
                return list;
            }
            else
            {
                const disc = discraftList.filter(disc => disc.model == searchObj.matches);
                if (disc.length > 0){
                    list.unshift(disc[0]);
                }
                return list;
            }
        }
        return list;
    }
}